export default (newPaymentFormData) => ({
  registrationNumber: newPaymentFormData?.registrationNumber,
  country: newPaymentFormData?.country,
  city: newPaymentFormData?.city,
  postCode: newPaymentFormData?.postCode,
  address: newPaymentFormData?.address
});
